import { render, staticRenderFns } from "./FullScreenContainer.vue?vue&type=template&id=33cf0e06&scoped=true"
import script from "./FullScreenContainer.vue?vue&type=script&lang=js"
export * from "./FullScreenContainer.vue?vue&type=script&lang=js"
import style0 from "./FullScreenContainer.vue?vue&type=style&index=0&id=33cf0e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cf0e06",
  null
  
)

export default component.exports